import { am } from './utils';
import config from './../config';

import httpClient from '@/utils/httpClient';

export const GET_TOPIC_COLLECTION = am('GET_TOPIC_COLLECTION');
export const UPDATE_RECORD = am('UPDATE_RECORD');
export const GET_NEXT_RECORD = am('GET_NEXT_RECORD');

export const APPEND = am('APPEND');
export const JOIN = am('JOIN');
export const LEAVE = am('LEAVE');

export const state = {
  isGetCollectionPending: false,
  isGetCollectionFailed: false,
  collection: [],
  total: 0,

  isGetNextRequestPending: false,
  isGetNextRequestFailed: false,

  isUpdateRequestPending: false,
  isUpdateRequestFailed: false,

  leaveRequestPendingCollection: [],
  leaveRequstFailedCollection: [],

  record: null
};

export const actions = {
  async my({ commit }) {
    commit(GET_TOPIC_COLLECTION.STARTED);
    try {
      const response = await httpClient.get(config.apihostname+`/annotate/my`);

      commit(GET_TOPIC_COLLECTION.COMPLETED, response);
    } catch (e) {
      commit(GET_TOPIC_COLLECTION.FAILED);
      throw e;
    }
  },
  async update({ commit }, { id, label }) {
    commit(UPDATE_RECORD.STARTED);
    try {
      await httpClient.put(config.apihostname+`/annotate/${id}/label`, { label });

      commit(UPDATE_RECORD.COMPLETED);
    } catch (e) {
      commit(UPDATE_RECORD.FAILED);
      throw e;
    }
  },
  async report({ commit }, { id, complaint }) {
    commit(UPDATE_RECORD.STARTED);
    try {
      await httpClient.put(config.apihostname+`/annotate/${id}/report`, { complaint });

      commit(UPDATE_RECORD.COMPLETED);
    } catch (e) {
      commit(UPDATE_RECORD.FAILED);
      throw e;
    }
  },
  async next({ commit }, { id }) {
    commit(GET_NEXT_RECORD.STARTED);
    try {
      const response = await httpClient.get(config.apihostname+`/annotate/next/${id}`);

      if (response.id && response.question && response.text) {
        commit(GET_NEXT_RECORD.COMPLETED, {
          id: response.id,
          question: response.question,
          text: response.text,
          progress: response.progress
        });
      } else {
        commit(GET_NEXT_RECORD.COMPLETED, null);
      }
    } catch (e) {
      commit(GET_NEXT_RECORD.FAILED);
      if (!e || !e.response || (e.response.status !== 403 && e.response.status !== 404)) {
        throw e;
      }
    }
  },

  async leave({ commit }, { id }) {
    commit(LEAVE.STARTED, { id });
    try {
      await httpClient.post(config.apihostname+`/annotate/leave/${id}`);
      commit(LEAVE.COMPLETED, { id });
    } catch (e) {
      commit(LEAVE.FAILED);

      throw e;
    }
  }
};

export const mutations = {
  [GET_TOPIC_COLLECTION.STARTED](state) {
    state.isGetCollectionPending = true;
    state.isGetCollectionFailed = false;
  },
  [GET_TOPIC_COLLECTION.COMPLETED](state, { data, total }) {
    state.isGetCollectionPending = false;
    state.isGetCollectionFailed = false;

    state.collection = data;
    state.total = total;
  },
  [GET_TOPIC_COLLECTION.FAILED](state) {
    state.isGetCollectionPending = false;
    state.isGetCollectionFailed = true;
  },

  [UPDATE_RECORD.STARTED](state) {
    state.isUpdateRequestPending = true;
    state.isUpdateRequestFailed = false;
  },
  [UPDATE_RECORD.FAILED](state) {
    state.isUpdateRequestPending = false;
    state.isUpdateRequestFailed = true;
  },
  [UPDATE_RECORD.COMPLETED](state) {
    state.isUpdateRequestPending = false;
  },
  [GET_NEXT_RECORD.STARTED](state) {
    state.isGetNextRequestPending = true;
    state.isGetNextRequestFailed = false;
  },
  [GET_NEXT_RECORD.FAILED](state) {
    state.isGetNextRequestPending = false;
    state.isGetNextRequestFailed = true;
  },
  [GET_NEXT_RECORD.COMPLETED](state, record) {
    state.isGetNextRequestPending = false;
    state.record = record;
  },

  [LEAVE.STARTED](state, { id }) {
    state.leaveRequestPendingCollection = Array.from(new Set([...state.leaveRequestPendingCollection, id]));
    state.leaveRequstFailedCollection = state.leaveRequstFailedCollection.filter(s => s !== id);
  },
  [LEAVE.FAILED](state, { id }) {
    state.leaveRequestPendingCollection = state.leaveRequestPendingCollection.filter(s => s !== id);
    state.leaveRequstFailedCollection = Array.from(new Set([...state.leaveRequstFailedCollection, id]));
  },
  [LEAVE.COMPLETED](state, { id }) {
    state.leaveRequestPendingCollection = state.leaveRequestPendingCollection.filter(s => s !== id);
    state.collection = state.collection.filter(topic => topic.id !== id);
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  modules: {
    search: {
      namespaced: true,

      state: {
        collection: [],
        total: 0,
        from: 0,
        isAppendRequestPending: false,
        isAppendRequestFailed: true,

        joinRequestPendingCollection: [],
        joinRequstFailedCollection: []
      },

      mutations: {
        [APPEND.STARTED](state, { initialize }) {
          state.isAppendRequestPending = true;
          state.isAppendRequestFailed = false;
          if (initialize) {
            state.collection = [];
          }
        },
        [APPEND.COMPLETED](state, { collection, total }) {
          state.isAppendRequestPending = false;

          for (const item of collection) {
            if (state.collection.find(({ id }) => item.id === id)) {
              continue;
            }
            state.collection.push(item);
          }

          state.total = total;
        },
        [APPEND.FAILED](state) {
          state.isAppendRequestPending = false;
          state.isAppendRequestFailed = true;
        },

        [JOIN.STARTED](state, { id }) {
          state.joinRequestPendingCollection = Array.from(new Set([...state.joinRequestPendingCollection, id]));
          state.joinRequstFailedCollection = state.joinRequstFailedCollection.filter(s => s !== id);
        },
        [JOIN.FAILED](state, { id }) {
          state.joinRequestPendingCollection = state.joinRequestPendingCollection.filter(s => s !== id);
          state.joinRequstFailedCollection = Array.from(new Set([...state.joinRequstFailedCollection, id]));
        },
        [JOIN.COMPLETED](state, { id }) {
          state.joinRequestPendingCollection = state.joinRequestPendingCollection.filter(s => s !== id);
          const topic = state.collection.find(topic => topic.id === id);
          if (topic) {
            topic.isAnnotator = true;
          }
        }
      },
      actions: {
        async append({ commit }, { skip, size, from, initialize = false }) {
          commit(APPEND.STARTED, { initialize });
          try {
            const params = {};
            if (+skip === skip) {
              params.skip = skip;
            }
            if (+size === size) {
              params.size = size;
            }

            if (from) {
              params.from = from;
            }

            const { data, total } = await httpClient.get(
              config.apihostname+`/annotate/search?${new URLSearchParams(params).toString()}`
            );

            commit(APPEND.COMPLETED, { collection: data, total });
          } catch (e) {
            commit(APPEND.FAILED);
            throw e;
          }
        },
        async join({ commit }, { id }) {
          commit(JOIN.STARTED, { id });
          try {
            await httpClient.post(config.apihostname+`/annotate/join/${id}`);
            commit(JOIN.COMPLETED, { id });
          } catch (e) {
            commit(JOIN.FAILED);

            throw e;
          }
        }
      }
    }
  }
};
